const CONTACTS_TAB_ROUTE_NAME = 'sw.customer.detail.contacts';
const CONTACTS_TAB_PATH = '/sw/customer/detail/:id/contacts';

Shopware.Module.register('topdata-contact-login-customer-extension', {
    type: 'plugin',

    routeMiddleware(next, currentRoute) {
        if (
            currentRoute.name === 'sw.customer.detail'
            && !currentRoute.children.some((child) => child.name === CONTACTS_TAB_ROUTE_NAME)
        ) {
            currentRoute.children.push({
                name: CONTACTS_TAB_ROUTE_NAME,
                path: CONTACTS_TAB_PATH,
                component: 'sw-customer-detail-contacts',
                meta: {
                    parentPath: 'sw.customer.index',
                    privilege: 'customer.viewer',
                },
            });
        }

        next(currentRoute);
    },
});